// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const lighthouse = defineModel({
  id: "lighthouse",
  batchId: "future",
  name: "Lighthouse",
  tags: ["building","lighthouse","low-poly","age-of-mcp","future","water"],
  summary: "Guides boats to harbour — a coastal prestige landmark.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.42, 0.5, 0.2, 7), color: "#7b7770", position: [0, 0.24, 0] },
      { geometry: new THREE.CylinderGeometry(0.34, 0.42, 0.14, 6), color: "#605d57", position: [0, 0.41, 0] },
      { geometry: new THREE.CylinderGeometry(0.3, 0.32, 0.24, 10), color: "#eef0ec", position: [0, 0.56, 0] },
      { geometry: new THREE.CylinderGeometry(0.28, 0.3, 0.24, 10), color: "#c43a32", position: [0, 0.8, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.35, 0.5, -0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.35, 0.5, -0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.35, 0.5, 0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.35, 0.5, 0.35] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.42, 0.5, 0.2, 7), color: "#7b7770", position: [0, 0.24, 0] },
      { geometry: new THREE.CylinderGeometry(0.34, 0.42, 0.14, 6), color: "#605d57", position: [0, 0.41, 0] },
      { geometry: new THREE.CylinderGeometry(0.3, 0.32, 0.18, 10), color: "#eef0ec", position: [0, 0.53, 0] },
      { geometry: new THREE.CylinderGeometry(0.28, 0.3, 0.18, 10), color: "#c43a32", position: [0, 0.71, 0] },
      { geometry: new THREE.CylinderGeometry(0.26, 0.28, 0.18, 10), color: "#eef0ec", position: [0, 0.89, 0] },
      { geometry: new THREE.CylinderGeometry(0.24, 0.26, 0.18, 10), color: "#c43a32", position: [0, 1.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.22, 0.24, 0.18, 10), color: "#eef0ec", position: [0, 1.25, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.7, 4), color: "#6b4a26", position: [-0.35, 0.85, -0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.7, 4), color: "#6b4a26", position: [0.35, 0.85, -0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.7, 4), color: "#6b4a26", position: [-0.35, 0.85, 0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.7, 4), color: "#6b4a26", position: [0.35, 0.85, 0.35] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.42, 0.5, 0.2, 7), color: "#7b7770", position: [0, 0.24, 0] },
      { geometry: new THREE.CylinderGeometry(0.34, 0.42, 0.14, 6), color: "#605d57", position: [0, 0.41, 0] },
      { geometry: new THREE.CylinderGeometry(0.3, 0.32, 0.2, 10), color: "#eef0ec", position: [0, 0.54, 0] },
      { geometry: new THREE.CylinderGeometry(0.28, 0.3, 0.2, 10), color: "#c43a32", position: [0, 0.74, 0] },
      { geometry: new THREE.CylinderGeometry(0.26, 0.28, 0.2, 10), color: "#eef0ec", position: [0, 0.94, 0] },
      { geometry: new THREE.CylinderGeometry(0.24, 0.26, 0.2, 10), color: "#c43a32", position: [0, 1.14, 0] },
      { geometry: new THREE.CylinderGeometry(0.22, 0.24, 0.2, 10), color: "#eef0ec", position: [0, 1.34, 0] },
      { geometry: new THREE.CylinderGeometry(0.2, 0.22, 0.2, 10), color: "#c43a32", position: [0, 1.54, 0] },
      { geometry: new THREE.CylinderGeometry(0.28, 0.28, 0.04, 10), color: "#3a3f44", position: [0, 1.66, 0] },
      { geometry: new THREE.TorusGeometry(0.25, 0.015, 4, 10), color: "#3a3f44", position: [0, 1.74, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.18, 0.18, 0.26, 8), color: "#bfe0e6", position: [0, 1.81, 0] },
      { geometry: new THREE.SphereGeometry(0.11, 8, 6), color: "#ffe6a0", position: [0, 1.81, 0] },
      { geometry: new THREE.CylinderGeometry(0.19, 0.19, 0.04, 8), color: "#3a3f44", position: [0, 1.96, 0] },
      { geometry: new THREE.ConeGeometry(0.22, 0.2, 8), color: "#3a3f44", position: [0, 2.08, 0] },
      { geometry: new THREE.SphereGeometry(0.03, 6, 5), color: "#3a3f44", position: [0, 2.21, 0] },
    ] },
  ],
  animations: [],
});
